import React, { useState } from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { makeStyles } from '@material-ui/core/styles'
import ListAltIcon from '@material-ui/icons/ListAlt'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'
import Divider from '@material-ui/core/Divider'
import TrailStepList from './TrailStepList'
import StyledSideBarItem from '../StyledSideBarItem'
import { NavLink } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import { GET_COURSE_PROGRESS } from '../../graphql/queries/courses'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    overflow: 'overlay'
  },
  menuLink: {
    color: '#000',
    borderLeft: `4px solid #F4F3F4`,
    '&:hover': {
      textDecoration: 'none',
      cursor: 'pointer'
    },
    '&.active-content': {
      borderLeftColor: `${theme.palette.primary.main}`
    }
  }
})
)

const CourseSideBarItems = ({ trails, currentContent, onClose, courseId, cronograma, apresentacao }) => {
  const classes = useStyles();
  const [fistTrailId, setFistTrailId] = useState('')

  const { data, loading, error } = useQuery(GET_COURSE_PROGRESS, {
    variables: { curso_id: courseId }
  })

  const getActiveContent = () => {
    return (trails || []).map((trailItem) => {
      return (trailItem.items || []).map((item) => {
        return (item.conteudos || []).findIndex(e => e._id === currentContent)
      })
    })
  }

  const menu = {}
  const sideBarInitializer = getActiveContent()
  sideBarInitializer.forEach((item, index) => {
    item.forEach((subItem, subIndex) => {
      if (subItem !== -1) {
        menu.subItem = subIndex
        menu.mainItem = index
        menu.contentItem = subItem
      }
    })
  })

  if (loading || error) {
    return null
  }

  const trailsFiltered = (trails || []).map(trail => {
    return {
      ...trail, items: (trail.items || []).map(item => {
        return {
          ...item, conteudos: ((item || {}).conteudos || []).map(content => {
            const concluido = !!(((data || {}).progressoCurso || {}).conteudos_concluidos || []).find(id => content._id === id)
            return { ...content, concluido }
          })
        }
      })
    }
  })

  return (
    <div className={classes.root}>
      {(cronograma &&
        <ListItem component={NavLink} to={'cronograma'} onClick={() => onClose && onClose('left')} className={classes.menuLink} activeClassName='active-content'>
          <ListItemIcon>
            <ListAltIcon />
          </ListItemIcon>
          <ListItemText primary={'Cronograma'} />
        </ListItem>
      )}
      <Divider />
      {(apresentacao &&
        <ListItem component={NavLink} to={'apresentacao'} onClick={() => onClose && onClose('left')} className={classes.menuLink} activeClassName='active-content'>
          <ListItemIcon>
            <PlayCircleOutlineIcon />
          </ListItemIcon>
          <ListItemText primary={'Apresentação'} />
        </ListItem>
      )}
      <Divider />
      {(trailsFiltered || []).map((step, key) => {

        const handleIsSelected = (selected) => {
          if (selected) {
            (selected) ? setFistTrailId(step.items[0]._id) : setFistTrailId('')
          }
        }

        return (
          <StyledSideBarItem 
            label={step.titulo} 
            parentIndex={key === menu.mainItem ? 0 : -1}
            index={key}
            className={classes.whiteBackGround}
            isSelected={(opt) => handleIsSelected(opt)}
          >
            <TrailStepList 
              onClose={onClose}
              content={step.items}
              currentContent={currentContent}
              menu={menu}
              parentIndex={sideBarInitializer[key] !== -1 ? 0 : -1}
              fistTrailId={fistTrailId}
              courseId={courseId}
            />
          </StyledSideBarItem>
        )
      }
        
      )}
    </div>
  );
}

export default CourseSideBarItems